export var SIDEBAR_WIDTH = 380;
export var SIDEBAR_BORDER_WIDTH = 1;
export var SIDEBAR_TOTAL_WIDTH = SIDEBAR_WIDTH + SIDEBAR_BORDER_WIDTH;